import { render, staticRenderFns } from "./PaymentAgentSelector.vue?vue&type=template&id=5bf0a692&"
import script from "./PaymentAgentSelector.vue?vue&type=script&lang=js&"
export * from "./PaymentAgentSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports